<template>
  <div class="popover contant">
    <div class="pop"
         v-if="showPop">
      <div class="pop-content">
        <div class="title">
          {{ $t('游戏账号删除协议') }}
        </div>
        <div class="iframe-content">
          <iframe :src="delete_agreement_url"
                  scrolling="yes"
                  frameborder="0"></iframe>
        </div>
        <div class="btn"
             @click="hideDetail">
          {{ $t('确定') }}
        </div>
      </div>
    </div>
    <div class="content progress-1">
      <div class="progress-content">
        <div class="top">
          <label>{{ $t('账号删除进程') }}</label>
          <label><span class="progress-num">{{progressNum}}</span>/6</label>
        </div>
        <div class="progress-bar">
          <div class="progress-reach"
               :style="{width:progressWidth}"></div>
        </div>
      </div>
      <div class="contain">
        <div class="success"
             v-if='showSuccess'>
          <img src="./images/delAccount.png"
               alt="success">
        </div>
        <div class="content-title">{{$t(delTitle)}}</div>
        <div>
          <div class="contain-1"
               v-if='page===1'>
            <h2>《{{ $t('游戏账号删除条件') }}》</h2>
            <p>
              {{ $t('1、账号必须事先绑定邮箱。删除账号需要用邮箱进行验证，确保是本人操作。') }}
            </p>
            <p>{{ $t('2、游戏收益已结清或得到妥善处理：包括但不局限于游戏代币、道具、会员权益等收益。请您妥善处理，若未处理，视为您自愿放弃该等收益。') }}</p>
            <p>{{ $t('3、账号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。') }}</p>
          </div>
          <div class="contain-2"
               v-if='page===2'>
            <h2>《{{ $t('游戏账号删除条件') }}》</h2>
            <p>
              {{ $t('亲爱的玩家，在您正式开始下一步有关本游戏的删除游戏账号流程前，请您务必先行仔细阅读、充分理解并同意《删除游戏账号协议》（以下统称“本协议”）。您按照游戏内提示的删除游戏账号之操作流程进行删除账号申请或开始删除账号流程的，或者您勾选本删除游戏账号协议并开始下一步操作的，均视为您已经同意和遵守本协议全部内容。') }}
            </p>
            <p>
              {{ $t('我们为您做出如下特别说明：在删除本游戏的游戏账号后，除法律法规或本协议另有规定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。前述个人信息包括但不限于头像、昵称、会员权益、等级/经验值等与游戏角色成长升级相关的所有数据、虚拟货币、虚拟道具等虚拟物品、聊天记录等内容。') }}
            </p>
            <p>
              {{ $t('有关删除游戏账号的其它详细规则及注意事项请点击查看') }}<span class="warning pop-line"
                    @click="showDetail">《{{ $t('删除游戏账号协议') }}》</span>
            </p>
          </div>
          <div class="contain-3"
               v-if='page===3'>
            <p>{{ $t('将删除的游戏账号：') }}</p>
            <div class="account">
              <label>{{ $t('游戏账号') }}</label>
              <span>{{username}}</span>
            </div>
            <div class="game-id">
              <label>{{ $t('游戏ID') }}</label>
              <span>{{user_id}}</span>
            </div>
            <div class="fail"
                 v-if="failContent!==''">
              <p>*{{ $t('失败原因') }}：</p>
              <div>
                <p>
                  {{$t(failContent)}}
                </p>
              </div>
            </div>
          </div>
          <div class="contain-4"
               v-if='page===4'>
            <p>{{ $t('亲爱的用户，为确保您的账号安全，请提供您账号绑定的邮箱验证码以供账号删除校验，该验证码仅用于本次验证使用') }}</p>
            <div class="phone">
              <span>{{userEmail}}</span>
            </div>
            <div class="verification">
              <input type="text"
                     :placeholder="$t('请输入验证码')"
                     v-model="code"
                     class="phone-code">
              <div class="verify-btn"
                   @click="verify"
                   v-if="counts === 60 || counts=== 0">
                {{ $t('获取验证码') }}
              </div>
              <div class="verify-btn isValidate"
                   v-else>
                {{counts}}s
              </div>
            </div>
          </div>
          <div class="contain-5"
               v-if='page===5'>
            <div class="reason">
              <p :class="{unactive:item.type !== type,active:item.type === type}"
                 v-for="item in reasons"
                 :key='item.type'
                 @click="getReason(item)">
                <i class="iconfont unactive-icon">
                  &#xe647;
                </i>
                <i class="iconfont active-icon">
                  &#xe649;
                </i>
                <span>{{$t(item.reason)}}</span>
              </p>
              <textarea name=""
                        id=""
                        cols="30"
                        rows="10"
                        maxlength='500'
                        :placeholder="$t('请描述你除账号的原因')"
                        class="reason-text"
                        v-if='showOther'
                        v-model='otherReason'>

              </textarea>
            </div>
          </div>
          <div class="contain-6"
               v-if='page===6'>
            <p>
              {{ $t('为防止误操作，请您再次确认是否删除游戏账号并确认删除后的影响，该影响包括但不限于（具体详见：') }}
              <span class="warning pop-line"
                    @click="showDetail">《{{ $t('删除游戏账号协议') }}》</span>):
            </p>
            <p>
              {{ $t('1.该账号一旦删除成功，您将无法登录、使用该游戏账号，且无法回复。除法律法规和《删除游戏账号协议》另有约定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。') }}
            </p>
            <p>
              {{ $t('2.您确认知悉，删除游戏账号的，该账号在本游戏使用期间已产生及未来可能产生是所有游戏收益或权益将会被全部删除/清除。据此，也特别提示您，在您开始删除本游戏账号前请您妥善处理您的游戏收益或权益。否则，账号删除后，我们有权利对该账号下的全部收益或权益做删除/清除处理，因此产生的后果由您自行承担，前游戏收益或权益包括但不限于账号内剩余的所有游戏虚拟货币、虚拟道具及其它虚拟物品及增值服务。') }}
            </p>
          </div>
          <div class="contain-7"
               v-if='page===7'>
            <p>{{ $t('您的游戏角色将于') }}
              <span class="warning time">{{deleted_at}}</span>
              {{ $t('完成删除。请注意，该账号删除有15日的冷静期(账号锁定期)。除法律法规规定和协议约定情形外 我们将在冷静期满后完成删除，删除或匿名化处理您的个人信息。') }}
            </p>
            <p class="careful">
              *{{ $t('在此期间，请您不要登录和使用该账号，以确保删除的顺利完成，否则视为您撤销删除申请。') }}
            </p>
          </div>
        </div>
      </div>
      <div class="operation-content"
           :style="{border:showOperationBorder}">
        <div class="remark"
             v-if="showOperationRemark">
          <div class="touch-content"
               @click="changeIcon"
               :class="{unactive:!isShowIcon,active:isShowIcon}">
            <i class="iconfont unactive-icon">
              &#xe647;
            </i>
            <i class="iconfont active-icon">
              &#xe649;
            </i>
          </div>
          <div>{{$t(operationSpan)}}
            <span class="warning pop-line"
                  onclick="showDetail()"
                  v-if="showLine">《 {{ $t('游戏账号删除协议') }}》</span>
          </div>

        </div>
        <div class="btn"
             v-if="!showSumbitBtns"
             @click="goToNext">
          {{$t(btnText)}}
        </div>
        <div class="sumbit-btns"
             v-else>
          <div class="sure-btn"
               @click="goToNext">
            {{ $t('确认删除游戏账号') }}
          </div>
          <div class="cancel-btn"
               @click="back">
            {{ $t('放弃删除') }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import connector from '../../common/js/nativeInterface';
import { nativeAjax, getMobileOperatingSystem, timestampToTime } from '../../common/js/utils';


export default {
  name: 'delAccount',
  data() {
    return {
      isLock: false,
      showPop: false,
      btnText: '下一步',
      type: '',
      isShowIcon: false,
      isLockApi: false,
      showSuccess: false,
      showLine: false,
      showOther: false,
      reasons: [
        { type: 1, reason: '这是个多余的账号' },
        { type: 2, reason: '弃游不想再玩' },
        { type: 3, reason: '需要解绑邮箱' },
        { type: 4, reason: '需要换绑实名认证信息' },
        { type: 99, reason: '其他' },
      ],
      timeStep: null,
      counts: 60,
      progressWidth: '30%',
      progressNum: 1,
      reason: {},
      delete_agreement_url: '',
      operationSpan: '我已详细阅读并满足删除账号条件',
      showOperationRemark: true,
      showOperationBorder: '',
      delTitle: '确认删除的游戏账号',
      step: -1,
      username: '123',
      userEmail: '',
      email: '12345',
      user_id: '123',
      showSumbitBtns: false,
      page: 1,
      failContent: '',
      auth_code: '',
      otherReason: '',
      deleted_at: '',
      code: '',
      isValidate: false,
    };
  },
  props: {
    compData: {
      type: Object,
    },
  },
  created() {
    window.showDetail = this.showDetail;
  },
  mounted() {
    if (getMobileOperatingSystem() === 'ios') {
      connector.getIOSInfoFn();
    }
    this.init(1);
  },
  methods: {
    init(step) {
      this.progressWidth = `${(100 / 6) * step}%`;
      this.step = step;
      this.isShowIcon = false;
      this.progressNum = step > 6 ? 6 : step;
      this.page = step;
      this.step += 1;
    },
    changePage(step) {
      this.showLine = false;
      switch (step - 1) {
        case 2:
          this.operationSpan = '我已详细阅读并同意';
          this.showLine = true;
          break;
        case 3:
          this.showOperationRemark = false;
          this.showOperationBorder = 'none';
          this.delTitle = '确认删除的游戏账号';
          break;
        case 4:
          this.showOperationRemark = false;
          this.showOperationBorder = 'none';
          this.delTitle = '验证本账号绑定的邮箱';
          break;
        case 5:
          this.showOperationRemark = false;
          this.showOperationBorder = 'none';
          this.delTitle = '选择删除的原因';
          break;
        case 6:
          this.showOperationRemark = false;
          this.showOperationBorder = 'none';
          this.delTitle = '再次确认是否删除游戏账号并确认删除后的影响';
          this.showSumbitBtns = true;
          break;
        case 7:
          this.showOperationRemark = false;
          this.showOperationBorder = 'none';
          this.delTitle = '删除游戏账号申请提交成功';
          this.showSumbitBtns = false;
          this.btnText = '完成';
          this.showSuccess = true;
          break;
        default:
          break;
      }
    },
    getReason(item) {
      this.type = item.type;
      this.reason = item;
      if (parseInt(item.type, 10) === 99) {
        this.showOther = true;
      }
    },
    back() {
      connector.callExit();
    },
    changeIcon() {
      this.isShowIcon = !this.isShowIcon;
    },
    verify() {
      if (!this.isValidate) {
        this.isValidate = true;
        this.getVerify();
        this.counts = 60;
        this.timeStep = setInterval(() => {
          this.counts -= 1;
          if (this.counts === 0) {
            clearInterval(this.timeStep);
            this.isValidate = false;
          }
        }, 1000);
      }
    },
    clearIntervalFn() {
      clearInterval(this.timeStep);
      this.counts = 60;
      this.isValidate = false;
    },
    getVerify() {
      nativeAjax({
        url: '/v1/verify',
        data: {
          game: {
            game_id: this.user.appId,
          },
          user: {
            email: this.user.email,
            access_token: this.user.token,
            user_id: this.user.userId,
          },
          verify: {
            api_action: 'cancel',
          },
        },
        callbackName: 'getEmailCode',
        callback: (res) => {
          switch (parseInt(res.ret, 10)) {
            case 1:
              this.$toast('验证码发送成功');
              break;
            case 70000002:
              this.clearIntervalFn();
              this.$toast('达到设备id验证码发送次数上限');
              break;
            case 70000003:
              this.clearIntervalFn();
              this.$toast('达到IP验证码发送次数上限');
              break;
            case 70000004:
              this.clearIntervalFn();
              this.$toast('验证码发送失败');
              break;
            case 70000009:
              this.clearIntervalFn();
              this.$toast('请求发送频率过快');
              break;
            default:
              this.clearIntervalFn();
              this.$toast(res.msg);
              break;
          }
        },
      });
    },
    showDetail() {
      this.showPop = true;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
    },
    hideDetail() {
      this.showPop = false;
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
    },
    goToNext() {
      switch (this.step) {
        case 2:
          // 确保点击已同意按钮
          if (!this.isShowIcon) {
            this.$toast('请先勾选【我已仔细阅读并满足账号删除条件】');
          } else {
            this.init(this.step);
            this.changePage(this.step);
          }
          this.user = connector.getDelInfo();
          this.delete_agreement_url = this.user.delUrl;
          break;
        case 3:
          this.username = this.user.username;
          this.user_id = this.user.userId;
          this.email = this.user.email;
          this.userEmail = this.user.email;

          // 确保点击已同意按钮
          if (!this.isShowIcon) {
            this.$toast('请先勾选【我已阅读并同意《游戏账号删除协议》】');
          } else {
            this.init(this.step);
            this.changePage(this.step);
          }
          break;
        case 4:
          this.failContent = '';
          if (this.email === '' || !this.email) {
            this.failContent +=
              '用户的游戏账号未绑定邮箱';
          }
          if (this.failContent !== '') {
            this.$toast('账号删除申请失败');
          } else {
            this.init(this.step);
            this.changePage(this.step);
          }
          break;
        case 5:
          if (this.code === '') {
            this.$toast('请输入验证码');
          } else if (!this.isLockApi) {
            this.isLockApi = true;
            nativeAjax({
              url: '/v1/email/examine',
              data: {
                game: {
                  game_id: this.user.appId,
                },
                user: {
                  email: this.user.email,
                  access_token: this.user.token,
                  user_id: this.user.userId,
                },
                verify: {
                  api_action: 'cancel',
                  code: this.code,
                },
              },
              callbackName: 'updateEmail',
              callback: (res) => {
                this.isLockApi = false;
                this.clearIntervalFn();
                switch (parseInt(res.ret, 10)) {
                  case 1:
                    this.$toast('验证成功');
                    this.auth_code = res.content.auth_code;
                    this.init(this.step);
                    this.changePage(this.step);
                    break;
                  case 70000003:
                    this.$toast('达到IP验证码发送次数上限');
                    break;
                  case 70000009:
                    this.$toast('请求发送频率过快');
                    break;
                  default:
                    this.$toast(res.msg);
                    break;
                }
              },
            });
          }
          break;
        case 6:
          if (this.reason.type && this.reason.type !== '') {
            this.init(this.step);
            this.changePage(this.step);
          } else {
            this.$toast('请选择删除原因');
          }
          break;
        case 7:
          if (!this.isLockApi) {
            let reason = '';
            const { type } = this.reason;
            if (parseInt(type, 10) === 99) {
              reason = this.otherReason;
            } else {
              reason = this.reason.reason;
            }
            this.isLockApi = true;
            nativeAjax({
              url: '/v1/account/cancel/task/create',
              data: {
                game: {
                  game_id: this.user.appId,
                },
                user: {
                  email: this.email,
                  access_token: this.user.token,
                  user_id: this.user.userId,
                },
                account_cancel: {
                  type,
                  auth_code: this.auth_code,
                  reason,
                },
              },
              callbackName: 'cancelAccount',
              callback: (res) => {
                this.isLock = false;
                switch (parseInt(res.ret, 10)) {
                  case 1:
                    this.$toast('验证成功');
                    this.init(this.step);
                    this.changePage(this.step);
                    this.clearIntervalFn();
                    this.deleted_at = timestampToTime(res.content.deleted_at);
                    break;
                  case 70000003:
                    this.$toast('达到IP验证码发送次数上限');
                    break;
                  case 70000009:
                    this.$toast('请求发送频率过快');
                    break;
                  default:
                    this.$toast(res.msg);
                    break;
                }
              },
            });
          }
          break;
        case 8:
          connector.callExit();
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
* {
  padding: 0;
  margin: 0;
}
.mask .popover {
  height: 100vh;
  justify-content: flex-start;
}
.back {
  font-size: 12px;
  position: absolute;
  left: 15px;
  width: 90px;
  span {
    color: #333;
  }
}
.content {
  height: calc(100vh - 150px);
  overflow: auto;
  padding-bottom: 102px;
}
/deep/.warning {
  color: #fcca19;
}
#loadingDiv {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  opacity: 0.8;
  z-index: 9999999999;
  background-color: rgba(0, 0, 0, 0.39);
  display: none;
  div {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
.pop {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.39);
  display: flex;
  justify-content: center;
  align-items: center;
  .pop-content {
    background-color: #fff;
    width: 90vw;
    .title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      line-height: 45px;
      color: #333333;
      border-bottom: 1px solid #dcdcdc;
    }
    .iframe-content {
      height: 40vh;
      min-height: 100px;
      padding: 10px;
      background: #fff;
      overflow: auto;
      border-bottom: 1px solid #dcdcdc;
      -webkit-overflow-scrolling: touch;
      iframe {
        height: 100%;
        width: 100%;
        overflow: auto;
      }
    }
    .btn {
      width: 90%;
      height: 46px;
      color: #000;
      background: #fcca19;
      line-height: 46px;
      text-align: center;
      margin: 15px auto;
      border: none;
    }
  }
}
.progress-content {
  position: fixed;
  top: 0;
  padding: 10px 20px 15px;
  font-size: 12px;
  color: #333;
  left: 0;
  right: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #f5f5f5;
  background: #fff;
  z-index: 9;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .progress-num {
      color: #fcca19;
    }
  }
  .progress-bar {
    width: 100%;
    height: 6px;
    border-radius: 50px;
    background: rgba(238, 238, 238, 0.39);
    margin-top: 5px;
    overflow: hidden;
    .progress-reach {
      width: 30%;
      height: 6px;
      border-radius: 50px;
      background-color: #fcca19;
    }
  }
}
.contain {
  margin-top: 53px;
  padding: 15px 10px 0;
  color: #717171;
  width: 100%;
  overflow: auto;
  font-size: 14px;
  line-height: 28px;
  box-sizing: border-box;
  .success {
    text-align: center;
    img {
      width: 90px;
      height: auto;
      margin: 20px auto;
    }
  }
  .content-title {
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    position: relative;
    margin-left: 8px;
    &::before {
      content: '';
      position: absolute;
      background: #fcca19;
      width: 3px;
      height: 8px;
      border-radius: 100px;
      left: -8px;
      top: 5px;
    }
  }
  h2 {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    margin: 5px 0;
  }
  .contain-2 {
    p:last-child {
      margin-top: 20px;
    }
  }
  .contain-3 {
    p {
      font-weight: 400;
      line-height: 20px;
      color: #333333;
      font-size: 14px;
      margin: 10px 0 15px;
    }
    .account,
    .game-id {
      width: 100%;
      background: rgba(248, 248, 248, 0.39);
      border: 1px solid #dcdcdc;
      border-radius: 4px;
      font-size: 15px;
      line-height: 40px;
      color: #cbcbcb;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 15px;
      label {
        color: #cbcbcb;
      }
      span {
        color: #cbcbcb;
      }
    }
    .game-id {
      margin-top: 10px;
    }
    .fail {
      margin-top: 15px;
      /deep/p {
        font-size: 12px;
        font-weight: bold;
        line-height: 20px;
        color: #ff4b4b;
        margin-block-start: 0;
        margin-block-end: 0;
        .iconfont {
          font-size: 12px;
          margin-right: 5px;
        }
      }
    }
  }
  .contain-4 {
    margin-top: 5px;
    p {
      font-size: 12px;
      line-height: 24px;
      color: #717171;
      margin-bottom: 15px;
    }
    .phone,
    .verification {
      width: 100%;
      background: rgba(248, 248, 248, 0.39);
      border: 1px solid #dcdcdc;
      border-radius: 4px;
      font-size: 15px;
      line-height: 40px;
      color: #cbcbcb;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 15px;
    }
    .phone {
      label {
        color: #cbcbcb;
      }
      span {
        color: #cbcbcb;
      }
    }
    .verification {
      position: relative;
      background: none;
      margin-top: 10px;
      height: 40px;
      label {
        color: #7c7c7c;
      }
      input {
        width: 60%;
        position: absolute;
        left: 0;
        background: transparent;
        border: none;
        height: 36px;
        outline: none;
        padding-left: 10px;
        &::placeholder {
          color: #c7c7c7;
        }
      }
      .verify-btn {
        position: absolute;
        right: 10px;
        width: 84px;
        height: 26px;
        border: 1px solid #fcc91d;
        opacity: 0.61;
        border-radius: 4px;
        text-align: center;
        line-height: 26px;
        background-color: #fcc91d;
        font-size: 12px;
        color: #000;
        &.isValidate {
          background: rgba(238, 238, 238, 0.39);
          font-size: 10px;
          color: #999999;
          border: none;
        }
      }
    }
  }
  .contain-5 {
    p {
      font-size: 14px;
      line-height: 20px;
      color: #717171;
      margin-top: 10px;
    }
    textarea {
      margin-top: 8px;
      border: none;
      width: 100%;
      border: 1px dotted #dcdcdc;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 5px;
      outline: none;
      box-shadow: 0 0 0 rgba(0, 0, 0, 0);
      -webkit-appearance: none;
    }
    .iconfont {
      font-size: 10px;
      margin-right: 5px;
    }
    .active-icon {
      color: #fcc91d;
    }
    .active {
      .unactive-icon {
        display: none;
      }
      .active-icon {
        display: inline-block;
      }
    }
    .unactive {
      .active-icon {
        display: none;
      }
      .unactive-icon {
        display: inline-block;
      }
    }
  }
  .contain-6 {
    margin-top: 10px;
    p {
      font-size: 14px;
      line-height: 28px;
      color: #717171;
      .pop-line {
        text-decoration: underline;
      }
    }
  }
  .contain-7 {
    margin-top: 10px;
    p {
      font-size: 14px;
      line-height: 28px;
      color: #717171;
    }
    .careful {
      font-size: 12px;
      margin-top: 15px;
      line-height: 24px;
      color: #ff0000;
    }
  }
}
.operation-content {
  background-color: #fff;
  border-top: 1px solid #f5f5f5;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  padding: 10px 20px 15px;
  line-height: 20px;
  color: #8e8e8e;
  font-size: 12px;
  z-index: 9;
  .remark {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .touch-content {
    margin-right: 5px;
    &::after {
      content: '';
      position: absolute;
      left: -10px;
      top: 0;
      bottom: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
    }
  }
  .pop-line {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: -10px;
      bottom: 20px;
      right: 20px;
      width: 200px;
      height: 40px;
    }
  }
  .iconfont {
    font-size: 12px;
    color: #cbcbcb;
    position: relative;
  }
  .active {
    .unactive-icon {
      display: none;
    }
    .active-icon {
      display: inline-block;
      color: #fcc91d;
    }
  }
  .unactive {
    .active-icon {
      display: none;
    }
    .unactive-icon {
      display: inline-block;
    }
  }
  .btn {
    width: 100%;
    height: 46px;
    background-color: #fcca19;
    color: #000;
    font-size: 15px;
    text-align: center;
    border: none;
    line-height: 46px;
    margin-top: 10px;
  }
  .sumbit-btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    color: #000;
    font-size: 15px;
    .sure-btn,
    .cancel-btn {
      background: #fcca19;
      text-align: center;
      width: 48%;
      height: 46px;
      line-height: 46px;
    }
    .cancel-btn {
      background: #ebebeb;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/delAccount/App.vue